import React from 'react'
import { Form, Icon, Input } from 'antd';
import { withNamespaces } from 'react-i18next';

const ValidationFormStep1Component = (props) => {

    if (props.currentStep !== 'Step 1') {
      return null
    }

    return(

        <div className="form-group" style={{ maxWidth: '600px' }}>

            <Form.Item>
                {props.getFieldDecorator('siteID', {
                    initialValue: props.siteID,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: props.i18n.t('Please input site id')
                    }],
                })(
                    <Input
                        disabled
                        prefix={<Icon type="medicine-box" style={{color: '#424242'}}/>}
                        id="siteID"
                        name="siteID"
                        placeholder={props.i18n.t('Site ID')}
                        autoFocus
                        allowClear
                    />
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('userID', {
                    initialValue: props.userID,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: props.i18n.t('Please input user id')
                    }],
                })(
                    <Input
                        prefix={<Icon type="skin" style={{color: '#424242'}}/>}
                        id="userID"
                        name="userID"
                        placeholder={props.i18n.t('User ID')}
                        allowClear
                    />
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('subjectID', {
                    initialValue: props.subjectID,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: props.i18n.t('Please input subject id')
                    }],
                })(
                    <Input
                        disabled
                        prefix={<Icon type="user" style={{color: '#424242'}}/>}
                        id="subjectID"
                        name="subjectID"
                        placeholder={props.i18n.t('Subject ID')}
                    />
                )}
            </Form.Item>



       </div>

    );
}

export const ValidationFormStep1 = withNamespaces()(ValidationFormStep1Component)



// WEBPACK FOOTER //
// ./src/components/ValidateRandomization/ValidateRandomizationStep1.js